import { auth } from '@/shared/lib';
import { resetDeviceNavigationState } from '@/entities/device';
import { useInboxStore, defaultInboxState } from '@/entities/inbox';
import { usePhysicianStore, defaultPhysicianState } from '@/entities/physician';
import { useRmaStore, resetRmaNavigationState, defaultRmaState } from '@/entities/rma';
import { resetStudyNavigationState } from '@/entities/study';
import {
  useSupportStore,
  resetSupportNavigationState,
  defaultSupportState,
} from '@/entities/support';
import { useUserStore, logoutUserState } from '@/entities/user';
import { useLoadingStore, defaultLoadingState } from '@/shared/model';

// Hấp thụ trọn nhánh LOGOUT_REQUEST của src/app/store/root-reducer.ts.
/**
 * Clears every client-side store and cached credential when the user signs out. Preserves the saved locale and the loginFrom entry across auth.logout, then resets the loading, physician, support, RMA, user and inbox stores to their defaults and clears the RMA, study, device and support navigation state.
 *
 * @returns Nothing.
 */
export const resetAppState = () => {
  // Port từ src/app/store/root-reducer.ts:27-33 (nhánh LOGOUT_REQUEST).
  const currentLocale = auth.getLocale();
  const loginFrom = auth.getLoginFrom();
  auth.logout();
  auth.saveLocale(currentLocale);
  // Quirk giữ nguyên: loginFrom null → ghi chuỗi "null". Đúng như reducer cũ.
  auth.setLoginFrom(loginFrom);

  useLoadingStore.setState(defaultLoadingState);
  usePhysicianStore.setState(defaultPhysicianState);
  useSupportStore.setState(defaultSupportState);
  useRmaStore.setState(defaultRmaState);
  resetRmaNavigationState();
  useUserStore.setState(logoutUserState);
  useInboxStore.setState(defaultInboxState);
  resetStudyNavigationState();
  resetDeviceNavigationState();
  resetSupportNavigationState();
};
